import React, { FunctionComponent, ReactElement } from "react";

import { AlignItems, FlexDirection, Layout, SpacingSize } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";

const classNames = bemClassNames("legend-item");
const legendHeader = classNames("header-text");
const legendDescription = classNames("description-text");

export type LegendItemComponentProps = {
    /** ikona legendy */
    readonly legendItemIcon: ReactElement;
    /** text předávaný header */
    readonly legendItemHeaderText: string;
    /** text předávaný description */
    readonly legendItemDescriptionText: string;
};

export const LegendItemComponent: FunctionComponent<LegendItemComponentProps> = ({ legendItemIcon, legendItemHeaderText, legendItemDescriptionText }) => (
    <Layout flexDirection={FlexDirection.column} spacingSizeHorizontal={SpacingSize.s} spacingSizeVertical={SpacingSize.xs}>
        <Layout alignItems={AlignItems.center}>
            {legendItemIcon}
            <Layout alignItems={AlignItems.flexEnd} spacingSizeLeft={SpacingSize.s}>
                <h1 className={legendHeader}>{legendItemHeaderText}</h1>
            </Layout>
        </Layout>
        <p className={legendDescription}>{legendItemDescriptionText}</p>
    </Layout>
);
